
const devBaseURL = 'http://127.0.0.1:4000';
const proBaseURL = '/';

// export const PermissionURL = "https://oce.fx696.com:59105";
// export const wikiSearchURL = "https://oce.fx994.com:5300";
// export const zorrolURL = "https://voice.fx994.com";

// export const wsBaseUrl = 'wss://stream.binance.com:9443';

// let country=localStorage.getItem('country')==='中国'
// export const wsBaseUrl = country?'wss://api3.wikitrade.com/stream':'https://stream.binance.com:9443';


export const BASE_URL = process.env.NODE_ENV === 'development' ? devBaseURL : proBaseURL;
export const TIMEOUT = 50000;
export const api = {
  exInfo: '/api/v3/exchangeInfo', //交易规范信息
  allTicker: '/stream', //websocket
  tickerDay: '/api/v3/ticker/24hr', //24hr 价格变动情况

  bitLogin: '/api/Permission/Login', // 登录天眼评分
  bitCode: '/zorro/zorro.json',
  bitScore: '/WikiSearch/wikibit/detail',

  klineHis: `/api/v3/klines`, // k线 history
  depth: `/api/v3/depth`, // 深度图
  // indexKline: `/api/quote/v1/index/klines`, // 指数k线
  // indexFormula: `/api/quote/v1/index/config`, // 指数计算公式
  recentTrade: '/api/v3/trades',

  serverTime: '/api/v3/time', // 服务器时间
  trade: `/api/quote/v1/trades`, // 最新成交
  quote: `/api/quote/v1/broker/tickers`, // 24小时行情http
}

export const langDefault = 'en';
export const kline_locale = {
  "en": "en",
  "zh-cn": "zh",
  "ko": "ko",
  "ja": "ja",
  "vi": "vi",
  "es-es": "es",
  'zh-tw': 'zh_TW',
  'zh-hk': 'zh_TW',
};

export const intlLocale = [
  {
    lang: "en",
    value: "en",
    text: 'English'
  },
  {
    lang: "zh-cn",
    value: "zh-cn",
    text: '中文(简体)'
  },
  {
    lang: "ko",
    value: "ko",
    text: '한국어'
  },
  {
    lang: "ja",
    value: "ja",
    text: '日本語',
  },
  {
    lang: "vi",
    value: "vi",
    text: 'Tiếng Việt',
  },
  {
    lang: 'zh-tw',
    value: 'zh-tw',
    text: '台灣(繁体中文)',
  },
  {
    lang: 'zh-hk',
    value: 'zh-hk',
    text: '香港(繁体中文)',
  },
  {
    lang: 'id',
    value: 'id',
    text: 'Indonesia'
  }
];

export const formats = {
  // 日期、时间
  date: {
    normal: {
      hour12: false,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    }
  }
};

export const kTheme = {
  dark: {
    up: "#38AF75", //38AF75
    down: "#E75A5B",
    bg: "#0E1D2C",
    grid: "rgb(27, 42, 58)", //122130
    cross: "#37a6ef",
    border: "#4d596e",
    text: "#6b7e93",
    areatop: "rgba(122, 152, 247, .1)",
    areadown: "rgba(122, 152, 247, .02)",
    line: "#737375"
  },
  light: {
    up: "#38AF75",
    down: "#E75A5B",
    bg: "#ffffff",
    grid: "#f7f8fa",
    cross: "#23283D",
    border: "#9194a4",
    text: "#9194a4",
    areatop: "rgba(71, 78, 112, 0.1)",
    areadown: "rgba(71, 78, 112, 0.02)",
    line: "#737375"
  }
};

export const bitLogin = {
  username: 'gsw',
  password: '2E6CAA66096F1D4BED0FE21EE5468FE2'
}
export const themeSource = ['dark', 'light'];
export const rangeSource = {
  redUp: {
    type: 'redUp',
    "up": {
      "main": "#EC4D5C", "light": "#EE5F6C", "dark": "#D44553",
    },
    "down": {
      "main": "#6BB96D", "light": "#7AC07C", "dark": "#60A762",
    }
  },
  greenUp: {
    type: 'greenUp',
    "up": {
      "main": "#6BB96D", "light": "#7AC07C", "dark": "#60A762",
    },
    "down": {
      "main": "#EC4D5C", "light": "#EE5F6C", "dark": "#D44553",
    },
  }
};

export const klineConfig = {
  CNY: "￥",
  UST: "$",
  // 行情页model/ws数据更新频率
  refresh_ws: 1000,
  // 当前币对 刷新频率 ms，
  refresh: 200,
  refresh_150: 150,
  // 深度刷新频率
  refresh_depth: 1000,
  // 行情页token列表刷新频率
  refresh_tokens: 500,
  // 盘口刷新频率
  refresh_handicap: 500,
  // 最新成交刷新频率
  refresh_trade: 300,
  //获取深度限制
  depthLimit: 500,
  depthShow: 300,
  // 深度精度值，"0"跟K线价格精度0区别
  depth: {
    100000000: -8,
    10000000: -7,
    1000000: -6,
    100000: -5,
    10000: -4,
    1000: -3,
    100: -2,
    10: -1,
    1: 0,
    0: 0,
    0.1: 1,
    0.01: 2,
    0.001: 3,
    0.0001: 4,
    0.00001: 5,
    0.000001: 6,
    "0.0000001": 7,
    "0.00000001": 8,
    "0.000000001": 9,
    "0.0000000001": 10,
    "0.00000000001": 11,
    "0.000000000001": 12,
  },
  // k线价格精度
  k: {
    0: 1,
    1: 10,
    2: 100,
    3: 1000,
    4: 10000,
    5: 100000,
    6: 1000000,
    7: 10000000,
    8: 100000000,
    9: 1000000000,
    10: 10000000000,
    11: 100000000000,
    12: 1000000000000,
  },
  // 最新成交展示条数
  trade_limit: 60,
  rowsPerPage: 10,
  rowsPerPage1: 20,
  rowsPerPage2: 50,
  rowsPerPageOptions: [5, 10, 20],
  // img host
  imghost: "https://static.hcdnin.com",
  sense_id: "1b140c59a6da8e906cb4b7ca6687e075",
  // 合约状态
  optionStatus: {
    SETTLE_NO: 0,
    SETTLE_DOING: 1,
    SETTLE_DONE: 2,
  },
  // 永续合约杠杆小数位
  lever_decimal: 2,
  fee: 0.005,
  // 保证金率保留8位小数
  initialMargin: 8,
  // 永续合约买卖方向
  sideMap: {
    BUY_OPEN: "买入开多",
    SELL_OPEN: "卖出开空",
    BUY_CLOSE: "买入平空",
    SELL_CLOSE: "卖出平多",
  },
  kline_type: [
    "1",
    "5",
    "15",
    "30",
    "60",
    "120",
    "240",
    "360",
    "720",
    "1440",
    "10080",
    "44640",
  ],
  kline_btns: [
    {
      slug: "Time", // 窄屏展示
      resolution: "1", // 传给K线的参数
      chartType: 3, // 图表类型
      res: "Time", // 区分分时与1m
      full: "Time", // 宽屏展示
    },
    {
      slug: "1m",
      resolution: "1",
      res: "1",
      option: [
        {
          resolution: "1",
          slug: "1m",
          full: "1min",
          res: "1",
        },
        {
          resolution: "5",
          slug: "5m",
          full: "5min",
          res: "5",
        },
        {
          resolution: "15",
          slug: "15m",
          full: "15min",
          res: "15",
        },
        {
          resolution: "30",
          slug: "30m",
          full: "30min",
          res: "30",
        },
      ],
    },
    {
      slug: "1H",
      resolution: "60",
      res: "60",
      option: [
        {
          resolution: "60",
          slug: "1H",
          full: "1hour",
          res: "60",
        },
        {
          resolution: "120",
          slug: "2H",
          full: "2hour",
          res: "120",
        },
        {
          resolution: "240",
          slug: "4H",
          full: "4hour",
          res: "240",
        },
        {
          resolution: "360",
          slug: "6H",
          full: "6hour",
          res: "360",
        },
        {
          resolution: "720",
          slug: "12H",
          full: "12hour",
          res: "720",
        },
      ],
    },
    {
      slug: "1D",
      resolution: "1440",
      res: "1440",
      full: "1day",
    },
    {
      slug: "1W",
      resolution: "10080",
      res: "10080",
      full: "1week",
    },
    {
      slug: "1M",
      resolution: "44640",
      res: "44640",
      full: "1mon",
    },
  ],
  REGIST_TYPE: {
    MOBILE: 1,
    EMAIL: 2,
  },
  REGISTER_OPTIONS: {
    ALL: 1,
    ONLY_PHONE: 2,
    ONLY_EMAIL: 3,
    EMAIL_AND_CHINA_PHONE: 4,
  },
  time_in_force: "GTC",

  REPAY_WAY: {
    PRINCIPAL: 1, // 还本金
    ALL: 2, // 还币还息
  },
  // 个性化配置默认值
  customConfig: {
    // 行情颜色方案,  0 = 绿涨红跌; 1 = 红涨绿跌
    up_down: 0,
  },

  ORDER_TYPE: {
    LIMIT: "limit",
    MARKET: "market",
    PLAN: "plan",
  },

  ENTRUST_TYPE: {
    NORMAL: "normal", // 普通委托
    PLAN: "plan", // 计划委托
  },

  RECEIVER_TYPE: {
    MOBILE: 1,
    EMAIL: 2,
  },

  CONVERT: {
    PRICE_TYPE: {
      STATIC: 1, // 固定价格
      FLOAT: 2, // 浮动价格
    },
  },

  // 验证码方式
  CODE_TYPE: {
    BIND_MOBILE: 5,
    BIND_EMAIL: 6,
    BIND_GA: 7,
    UNBIND_EMAIL: 17,
    UNBIND_MOBILE: 18,
    UNBIND_GA: 19,
    CHANGE_BIND_EMAIL: 25,
    CHANGE_BIND_MOBILE: 26,
    CHANGE_BIND_GA: 27,
    CHANGE_BIND_EMAIL_NEW: 28,
    CHANGE_BIND_MOBILE_NEW: 29,
  },

  ACCOUNT_TYPE: {
    COIN: 0,
    MARGIN: 27,
  },

  KYC_TYPE: {
    UNDEFINED: 0,
    PERSON: 1,
    INSTITUTIONS: 2,
  },

  MARGIN_ACTIVITY_ERROR_TYPE: {
    NOT_START: 30050,
    NO_LOAN: 80028,
    NO_ASSETS: 33001,
    NEED_KYC2: 31517,
    EXCEED_LIMIT: 80029,
  },
};



